export default {
  "hash": "7f7da4f",
  "raw": "v3.27.1",
  "semverString": "3.27.1"
};